import { Box, Button } from '@mui/material'
import { useTranslation } from 'react-i18next'

import Tooltip from 'components/Tooltip'
import { SaveButtonProps } from './types'

export const SaveButton = ({
  can = true,
  formId,
  id,
  loading,
  onConfirmation,
  text,
  tooltip,
  touched,
  valid,
  variant = 'contained',
}: SaveButtonProps): JSX.Element => {
  const { t: tCommon } = useTranslation('common')

  const buttonId: string = `${formId}-save-button`
  const isDisabled: boolean = !can || !touched || loading || !valid

  const ButtonContainer = (
    <Button
      data-cy={id || buttonId}
      disabled={isDisabled}
      form={formId}
      id={id || buttonId}
      onClick={onConfirmation}
      sx={{ width: 'fit-content' }}
      type='submit'
      variant={variant}
    >
      {text || tCommon('form.action.save')}
    </Button>
  )

  return tooltip ? (
    <Tooltip {...tooltip}>
      <Box>{ButtonContainer}</Box>
    </Tooltip>
  ) : (
    ButtonContainer
  )
}
